<div
  *ngIf="!control.hidden"
  [hidden]="
    control.showWhen && group.get(control.showWhen.controlName) && group.get(control.showWhen.controlName)?.value !== control.showWhen.value
  "
>
  <ng-container *ngIf="control.name">
    <ng-container [ngSwitch]="control.type">
      <ng-container *ngSwitchCase="formType.repeat">
        <air-repeat-control
          [group]="group"
          [control]="control"
          [formState]="formState"
          [ngClass]="{ grid: repeatControl.fullWidth === false }"
          [showMandatory]="showMandatory"
          [userEventSource]="userEventSource"
        ></air-repeat-control>
      </ng-container>
      <ng-container *ngSwitchCase="formType.checkbox">
        <air-checkbox-control
          [group]="group"
          [control]="control"
          [formState]="formState"
          [userEventSource]="userEventSource"
        ></air-checkbox-control>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container *ngTemplateOutlet="formControlTemplate"></ng-container>
      </ng-container>
    </ng-container>
    <div class="form-error" *ngIf="control.type !== formType.repeat && control.hasError && control.errorMessages?.length">
      <div class="form-error__message" *ngFor="let message of control.errorMessages">
        {{ message }}
      </div>
    </div>
    <p class="form-message--card-status" *ngIf="cardStatusCheckError?.error">
      <ng-container [ngSwitch]="cardStatusCheckError.response">
        <ng-container *ngSwitchCase="cardStatus.hasAccount">
          {{ "account.error.card_number.has_account" | translate }}
          <a (click)="openLoginModal()">{{ "account.error.login" | translate }}</a> {{ "account.error.or" | translate }}
          <a (click)="openPrefilledPasswordResetModal(formValidatorTypeKeys.checkCardStatus)">
            {{ "account.error.reset_your_password" | translate }}
          </a>
          .
        </ng-container>
        <ng-container *ngSwitchCase="cardStatus.notFound">
          <span class="form-error">{{ "account.error.card_number.not_found" | translate }}</span>
        </ng-container>
      </ng-container>
    </p>
    <p class="form-message--user-exists" *ngIf="checkUserExistenceError?.error">
      <ng-container *ngIf="!isLoggedIn">
        {{ "account.error.email.exists" | translate }}
        <a (click)="openLoginModal()">{{ "account.error.login" | translate }}</a>
        ,
        <a (click)="openPrefilledPasswordResetModal(formValidatorTypeKeys.checkUserExistence)">
          {{ "account.error.reset_your_password" | translate }}
        </a>
        {{ "account.error.or" | translate }} {{ "account.error.use_another_email" | translate }}.
      </ng-container>
      <ng-container *ngIf="isLoggedIn">
        {{ "account.error.email.exists_verification" | translate }}
      </ng-container>
    </p>
    <p class="form-message--invalid-postal-code" *ngIf="postalCodeCheckError?.error">
      {{ "account.error.postal_code.invalid" | translate }}
    </p>
    <p class="form-error" *ngIf="hasError('passwordLogin')">
      {{ "account.error.password.invalid_login" | translate }}
      <a (click)="openPasswordResetModal()">{{ "account.error.reset_your_password" | translate }}</a>
    </p>
  </ng-container>

  <div
    *ngIf="control.description && !control.textOnlyDescription"
    class="form__description"
    [internalInnerHtml]="control.description"
    [userEventSource]="userEventSource"
  ></div>
  <small
    *ngIf="control.description && control.textOnlyDescription"
    class="form__description"
    [internalInnerHtml]="control.description"
    [userEventSource]="userEventSource"
  ></small>

  <ng-template #formControlTemplate>
    <div class="form-group">
      <label
        [for]="control.name"
        [ngClass]="{
          'form-label--error': control.hasError
        }"
        *ngIf="control.label"
      >
        {{ control.label }}
        <span *ngIf="showMandatory">*</span>
      </label>
      <ng-container [ngSwitch]="control.type">
        <ng-container *ngSwitchCase="formType.radio">
          <air-radio-control
            [group]="group"
            [control]="control"
            [formState]="formState"
            [userEventSource]="userEventSource"
          ></air-radio-control>
        </ng-container>
        <ng-container *ngSwitchCase="formType.select">
          <air-select-control [group]="group" [control]="control" [formState]="formState"></air-select-control>
        </ng-container>
        <ng-container *ngSwitchCase="formType.password">
          <air-password-control [group]="group" [control]="control" [formState]="formState"></air-password-control>
        </ng-container>
        <ng-container *ngSwitchCase="formType.textarea">
          <air-textarea-control [group]="group" [control]="control" [formState]="formState"></air-textarea-control>
        </ng-container>
        <ng-container *ngSwitchCase="formType.numeric">
          <air-numeric-control [group]="group" [control]="control" [formState]="formState"></air-numeric-control>
        </ng-container>
        <ng-container *ngSwitchCase="formType.file">
          <air-file-control
            [group]="group"
            [control]="control"
            [formState]="formState"
            [userEventSource]="userEventSource"
            (files)="setFiles($event)"
            (busy)="setFilesBusy($event)"
          ></air-file-control>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <air-text-control
            [group]="group"
            [control]="control"
            [formState]="formState"
            [userEventSource]="userEventSource"
          ></air-text-control>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>
</div>
